/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Archaeological_Sciences29Inputs */

const en__field__enum_additionalstudyinterests_study_archaeological_sciences29 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Archaeological_Sciences29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archaeological Sciences`)
};

const de__field__enum_additionalstudyinterests_study_archaeological_sciences29 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Archaeological_Sciences29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archäologische Wissenschaften`)
};

/**
* | output |
* | --- |
* | "Archaeological Sciences" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Archaeological_Sciences29Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_archaeological_sciences29 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Archaeological_Sciences29Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Archaeological_Sciences29Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_archaeological_sciences29(inputs)
	return de__field__enum_additionalstudyinterests_study_archaeological_sciences29(inputs)
});
export { _field__enum_additionalstudyinterests_study_archaeological_sciences29 as "_field__enum_additionalStudyInterests_STUDY_ARCHAEOLOGICAL_SCIENCES" }